import { Crosshair } from "lucide-react";
import { NavLink } from "react-router-dom";

const link = ({ isActive }: { isActive: boolean }) =>
  `text-sm ${isActive ? "text-accent" : "text-ink-2 hover:text-ink-1"}`;

export function TopNav() {
  return (
    <header className="flex items-center justify-between border-b border-line bg-bg-1 px-6 py-3">
      <div className="flex items-center gap-6">
        <div className="flex items-center gap-2 font-semibold text-ink-1">
          <Crosshair size={18} className="text-accent" />
          RepoHunt
        </div>
        <nav className="flex gap-4">
          <NavLink to="/hunt" className={link}>
            Охота
          </NavLink>
          <NavLink to="/history" className={link}>
            История
          </NavLink>
          <NavLink to="/favorites" className={link}>
            Избранное
          </NavLink>
          <NavLink to="/presets" className={link}>
            Пресеты
          </NavLink>
        </nav>
      </div>
      <form method="post" action="/logout">
        <button type="submit" className="text-sm text-ink-2 hover:text-ink-1">
          Выйти
        </button>
      </form>
    </header>
  );
}
